import * as d3 from "d3";
import {
    colonAnnotation,
    contextMenu,
    createTooltip,
    fw_progressive_1way,
    generateDownloadData,
    numberFormat
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)
    console.log("chart:",chart)

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
        renames "values" keys to "children" */
        obj.name = obj.key;
        delete obj.key;
        if (obj.values) {
            obj.children = obj.values;
            delete obj.values;
            obj.children.forEach(renameKeys);
        }
        return obj;
    };

    // axios.post(url, filterParam).then(res => {
        let data = resData;

        var nest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim2_name;
            }).sortKeys(d3.ascending)
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1;
                })
            })
            .entries(data);

        /*The visualization requires there to be a root node*/
        var flareData = {key: chart.y1AxisDisplayName, values: []};
        flareData.values = nest;
        renameKeys(flareData);

        (function visualize() {
            var diameter = chart.width;

            var svg = d3.select(divId).select("svg").remove();
            svg = d3.select(divId)
                .append("svg")
                .attr("width", chart.width+chart.margin.left+chart.margin.right)
                .attr("height", chart.height+chart.margin.top+chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + chart.width/2+", "+ chart.width/2 +")");  // Remove the centering transform


            var g = svg.append("g")
                .attr('transform',"translate("+(chart.margin.left+chart.margin.right + chart.width)/2+","+(chart.margin.top+chart.margin.bottom)/2+")")
            var metric1ColorScale = d3.scaleLinear()
                .domain([-1, 5])
                .range(["hsl(152,80%,80%)", "hsl(228,30%,40%)"])
                .interpolate(d3.interpolateHcl);

            var metric2ColorScale = d3.scaleOrdinal(fw_progressive_1way)

            var pack = d3.pack()
                .size([diameter, chart.height])
                .padding(0);  // Remove padding between nodes

            var root = d3.hierarchy(flareData)
                .sum(function (d) {
                    return d.value;
                })
                .sort(function (a, b) {
                    return b.value - a.value;
                });

            var focus = root,
                nodes = pack(root).descendants(),
                view;

            // d3.select("tooltip" + divId.id).remove();  // Clear tooltip
            // var div = d3.select(divId).append('div').attr('class', 'tooltip')
            //     .attr('style', 'position: absolute; opacity: 0;');

            const tooltip = createTooltip(divId);

            var circle = g.selectAll("circle")
                .data(nodes)
                .enter()
                .append("circle")
                .attr("class", function (d) {
                    return d.parent ? d.children ? "nodes" : "node node--leafcircle" : "node node--root";
                })
                .style("fill", function (d) {
                    return d.children ? metric1ColorScale(d.depth) : // Add the colours dynamically
                        d.data.name.startsWith('1_C') ? "#00FF00" : d.data.name.startsWith('2_P') ? '#90EE90' : d.data.name.startsWith('3_L') ? "#FFFF00" : d.data.name.startsWith('4_I') ? "#FF0000" : metric2ColorScale(d.data.name);
                })
                .on("click", function (d) {
                    if (focus !== d) zoom(d), d3.event.stopPropagation();
                })
                .on('mouseover', function(d) {
                    tooltip.onMouseOver(d, this, data =>data.data.name + colonAnnotation + numberFormat(data.value) )  // Pass tooltip content
                })
                .on('mousemove', tooltip.onMouseMove)
                .on('mouseleave', function() {
                    tooltip.onMouseLeave(this);
                })
                .on('contextmenu', function(d) {
                    const dimensionKey =
                        d.depth === 1 ? chart.insightNavigator.realDataFieldNames.x1RealDataFieldName :
                            d.depth === 2 ? chart.insightNavigator.realDataFieldNames.y1RealDataFieldName :
                                chart.insightNavigator.realDataFieldNames.x2RealDataFieldName;
                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [dimensionKey]: [d.data.name]               // e.g., "metric1"
                    };
                    console.log("clickedData",clickedData);
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });
                // .on("mousemove", function (d) {
                //     console.log(d3.event, d)
                //     div.transition()
                //         .duration(200)
                //         .style("opacity", .9);
                //     div.html(d.data.name + colonAnnotation + numberFormat(d.value))
                //         .style("left", (d3.event.pageX) + "px")
                //         .style("top", (d3.event.pageY) + "px");
                // })
                // .on("mouseout", function () {
                //     div.transition().style("opacity", 0)
                // });
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            g.selectAll("text")
                .data(nodes)
                .enter()
                .append("text")
                .attr("class", "labels")
                .style("display", (d) => {
                    return d.parent === root ? "inline" : "none"
                })
                .text((d) => {
                    return d.data.name
                });

            var node = g.selectAll("circle,text");

            svg.style("background", metric1ColorScale(-1))
                .on("click", function () {
                    zoom(root);
                })

            zoomTo([root.x, root.y, root.r * 2]);

            function zoom(d) {
                focus = d;

                var transition = d3.transition()
                    .duration(d3.event.altKey ? 7500 : 750)
                    .tween("zoom", function () {
                        var i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * 2]);
                        return function (t) {
                            zoomTo(i(t));
                        };
                    });

                transition.selectAll("text")
                    .filter(function (d) {
                        return d.parent === focus || this.style.display === "inline";
                    })
                    .style("fill-opacity", function (d) {
                        return d.parent === focus ? 1 : 0;
                    })
                    .on("start", function (d) {
                        if (d.parent === focus) this.style.display = "inline";
                    })
                    .on("end", function (d) {
                        if (d.parent !== focus) this.style.display = "none";
                    });
            }

            function zoomTo(v) {
                console.log("changessss",v[2])
                var k = diameter / v[2];
                view = v;
                node.attr("transform", function (d) {
                    return "translate(" + ((d.x - v[0]) * k) + "," + ((d.y - v[1]) * k) + ")";
                });
                circle.attr("r", function (d) {
                    return d.r * k;
                });
            }

            function responsivefy(svg) {
                var container = d3.select(svg.node().parentNode),
                    width = parseInt(svg.style("width")),
                    height = parseInt(svg.style("height")),
                    aspect = width / height;

                svg.attr("viewBox", "0 0 " + width*2 + " " + height*2)
                    .attr("preserveAspectRatio", "xMinYMid")
                    .call(resize);

                d3.select(window).on("resize." + container.attr("id"), resize);

                function resize() {
                    var targetWidth = parseInt(container.style("width"));
                    svg.attr("width", targetWidth);
                    svg.attr("height", Math.round(targetWidth / (aspect)));
                }
            }
        })(flareData);
    // });
}
